<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-toolbar-title>Gazetted & Company Public Holiday</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-menu
        bottom
        left
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, i) in items"
            :key="i"
            click
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-dialog
        v-model="dialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container fluid>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                >
                  <v-checkbox
                    label="There is Holiday"
                    prepend-icon="track_changes"
                  ></v-checkbox>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                >
                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"                    
                    :loading="loading"
                    cache-items                    
                    flat
                    chips
                    placeholder="Select only suggested Work Month"
                    v-model="editItem.WorkMonth"
                    label="WorkMonth"
                    prepend-icon="event"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                >
                  <v-autocomplete
                    hint="Atleast 3 Characters required"                    
                    :loading="loading"
                    cache-items                   
                    flat
                    chips
                    placeholder="Select only suggested Type"
                    v-model="editedItem.Type"
                    label="Type"
                    prepend-icon="track_changes"
                  ></v-autocomplete>
                </v-flex>
                <!-- <v-flex xs12 sm6 md4>
                 <v-text-field
                  label="Holiday Date"
                   :error-messages="errors.collect('HolidayDate')"               
                   type="date"                    
                     required
                     prepend-icon="date_range"                      
                     v-model="editedItem.HolidayDate"       
                     ></v-text-field>         
                </v-flex>
                <v-flex xs12 sm6 md4>  
                <v-text-field  label="Description"  prepend-icon="description"  v-model="editedItem.Description"       ></v-text-field> 
                </v-flex>
                <v-flex xs12 sm6 md4>
                <v-select  label="Status"  prepend-icon="level" v-model="editedItem.Status" ></v-select> 
                </v-flex> -->
                <v-flex
                  xs12
                  sm12
                >
                  <v-text-field
                    multiple
                    label="Task Content"
                    prepend-icon="notes"
                    v-model="editedItem.TaskContent"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="TriggerDate"
                    :error-messages="errors.collect('Date')"
                    type="date"
                    required
                    prepend-icon="event"
                    v-model="editedItem.TriggerDate"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="TaskDueDate"
                    :error-messages="errors.collect('Date')"
                    type="date"
                    required
                    prepend-icon="event"
                    v-model="editedItem.TaskDueDate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="close"
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="save"
            >Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>
          <v-checkbox
            primary
            hide-details
          ></v-checkbox>
        </td>
        <td>{{ props.item.WorkMonth }}
        </td>
        <td>{{ props.item.Type }}</td>
        <td>{{ props.item.HolidayDate }}</td>
        <td class="text-xs-left">{{ props.item.Description }}</td>
        <td class="text-xs-left">{{ props.item.Status }}</td>
        <td>{{ props.item.TriggerDate }}</td>
        <td class="text-xs-left">{{ props.item.TaskContent }}</td>
        <td>{{ props.item.TaskDueDate }}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          @click="initialize"
        >Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    search: '',
    items: [
      { title: 'Clear Items' },
      { title: 'Edit details' },
      { title: 'Delete' }
    ],

    headers: [
      {
        text: 'There is Holiday',
        align: 'left',
        sortable: true,
        value: 'There is Holiday'
      },
      {
        text: 'WorkMonth',
        align: 'left',
        sortable: true,
        value: 'WorkMonth'
      },
      {
        text: 'Type',
        align: 'left',
        value: 'Type'
      },
      { text: 'HolidayDate.', value: 'HolidayDate' },
      { text: 'Description', value: 'Description' },
      { text: 'Status', value: 'Status' },
      { text: 'TriggerDate', value: 'TriggerDate' },
      { text: 'TaskContent', value: 'TaskContent' },
      { text: 'TaskDueDate', value: 'TaskDueDate' },
      { text: 'Action', value: 'action', align: 'right' }
    ],

    desserts: [],
    editedIndex: -1,
    editedItem: {

      Type: '',
      WorkMonth: '',
      HolidayDate: '',
      Description: '',
      Status: '',
      TriggerDate: '',
      TaskContent: '',
      TaskDueDate: ''
    },
    defaultItem: {

      Type: '',
      WorkMonth: '',
      HolidayDate: '',
      Description: '',
      Status: '',
      TriggerDate: '',
      TaskContent: '',
      TaskDueDate: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.desserts = [
        {
          Type: 'Cl',
          WorkMonth: 'january',
          HolidayDate: '2018-11-16',
          Description: 'first type',
          Status: 'Active',
          TriggerDate: '2018-11-16',
          TaskContent: 'task first',
          TaskDueDate: '2018-11-16'
        },
        {
          Type: 'Type',
          WorkMonth: 'febraury',
          HolidayDate: '2018-11-16',
          Description: 'Second type',
          Status: 'Active',
          TriggerDate: '2018-11-16',
          TaskContent: 'task second',
          TaskDueDate: '2018-11-16'
        },
        {
          Type: 'work',
          WorkMonth: 'March',
          HolidayDate: '2018-11-16',
          Description: 'Third type',
          Status: 'Active',
          TriggerDate: '2018-11-16',
          TaskContent: 'task third',
          TaskDueDate: '2018-11-16'
        }
      ];
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/widgets/list/WorkDateMonths.vue